import React from "react";
import { useState, useContext, useEffect, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import MaskedInput from "react-text-mask";

import { TextField } from "@material-ui/core";

import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  InputAdornment,
} from "@material-ui/core";

import CurrencyTextField from "@unicef/material-ui-currency-textfield";

import { APIContext } from "../../context";

function RucTextMask(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        /[0-9]/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholderChar={"\u2000"}
      //showMask
    />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    //backgroundColor: theme.palette.background.paper,
    width: "100%",
  },
  formControl: {
    //padding: theme.spacing(1, 2, 2 , 2),
  },
  TituloForm: {
    textTransform: "Uppercase",
    fontWeight: "600",
    marginBottom: theme.spacing(2),
  },
  SubTituloForm: {
    marginBottom: theme.spacing(2),
  },
  Divider: {
    margin: theme.spacing(3, 0, 3, 0),
    backgroundColor: theme.palette.primary.main,
    height: "2px",
  },
  Input: {
    color: theme.palette.secondary.main,
    borderColor: theme.palette.primary.main,
  },
  InputBase: {
    textTransform: "Uppercase",
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.secondary.main,
  },
  card: {
    // boxShadow: 'none',
    backgroundColor: "#fff",
    color: theme.palette.secondary.main,
    padding: theme.spacing(2, 2, 2, 2),
    borderColor: "#cccecea3",
    marginBottom: theme.spacing(3),
  },
  containerButton: {
    textAlign: "center",
  },
  buttonCalcular: {
    textTransform: "capitalize",
    paddingLeft: "3rem",
    paddingRight: "3rem",
    lineHeight: "1.5rem",
    letterSpacing: "0.1rem",
    fontSize: "1.2rem",
    color: "#fff",
    float: "right",
  },
}));

export default function Formulario() {
  const classes = useStyles();
  const [err, setErr] = useState(false);
  const [formulas, setFormulas] = useState({
    anticipo: 0,
    gao: 0,
    tasa_descuento: 0,
    dias: 0,
  });

  const { updateFormulasSimulador, redirect_error } = useContext(APIContext);

  useEffect(() => {
    if (err) {
      redirect_error();
    }
  }, [err, redirect_error]);

  const _init = useCallback(async () => {
    const API_URL = process.env.REACT_APP_API_URL;

    try {
      const url = `${API_URL}formula`;
      const response = await fetch(url);
      const data = await response.json();
      if (data.error) {
        setErr(true);
      } else {
        setFormulas(data.body[0]);
      }
    } catch (err) {
      console.log(err);
    }
  }, []);

  useEffect(() => {
    _init();
  }, [_init]);

  return (
    <>
      <Card className={classes.card} variant="outlined">
        <CardContent className={classes.FormBase}>
          <Box display="flex" flexDirection="column" p={0} mt={3}>
            <Box display="flex" flexDirection="row" p={0} my={1}>
              <Box width="280px" mr={2}>
                <Typography variant="h6" color="primary" align="left">
                  Anticipo
                </Typography>
              </Box>
              <Box ml={2} width="100px">
                <CurrencyTextField
                  currencySymbol=""
                  name="anticipo"
                  value={formulas.anticipo}
                  minimumValue="0"
                  maximumValue="100"
                  variant="outlined"
                  placeholder="Anticipo"
                  className={classes.InputBase}
                  size="small"
                  outputFormat={"number"}
                  //decimalPlacesShownOnBlur={0}
                  //decimalPlacesShownOnFocus={0}
                  onChange={(e) => {}}
                  onBlur={(e, newValue) => {
                    setFormulas({ ...formulas, [e.target.name]: newValue });
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">%</InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Box>
            {/* <Box display="flex" flexDirection="row" p={0} my={1}>
              <Box width="280px" mr={2}>
                <Typography variant="h6" color="primary" align="left">
                  Gasto Administrativo Operativo
                </Typography>
              </Box>
              <Box ml={2} width="100px">
                <CurrencyTextField
                  currencySymbol=""
                  name="gasto_admin_operativo"
                  value={formulas.gasto_admin_operativo}
                  minimumValue="0"
                  maximumValue="100"
                  variant="outlined"
                  placeholder="GAO"
                  className={classes.InputBase}
                  size="small"
                  outputFormat={"number"}
                  //decimalPlacesShownOnBlur={0}
                  //decimalPlacesShownOnFocus={0}
                  onChange={(e) => {}}
                  onBlur={(e, newValue) => {
                    setFormulas({ ...formulas, [e.target.name]: newValue });
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">%</InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Box> */}
            <Box display="flex" flexDirection="row" p={0} my={1}>
              <Box width="280px" mr={2}>
                <Typography variant="h6" color="primary" align="left">
                  Tasa
                </Typography>
              </Box>
              <Box ml={2} width="100px">
                <CurrencyTextField
                  currencySymbol=""
                  name="tasa_descuento"
                  value={formulas.tasa_descuento}
                  minimumValue="0"
                  maximumValue="100"
                  variant="outlined"
                  placeholder="tasa descuento"
                  className={classes.InputBase}
                  size="small"
                  outputFormat={"number"}
                  //decimalPlacesShownOnBlur={0}
                  //decimalPlacesShownOnFocus={0}
                  onChange={(e) => {}}
                  onBlur={(e, newValue) => {
                    setFormulas({ ...formulas, tasa_descuento: newValue });
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">%</InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Box>
            <Box display="flex" flexDirection="row" p={0} my={1}>
              <Box width="280px" mr={2}>
                <Typography variant="h6" color="primary" align="left">
                  Días
                </Typography>
              </Box>
              <Box ml={2} width="100px">
                <TextField
                  id="dias"
                  name="dias"
                  value={formulas.dias}
                  variant="outlined"
                  placeholder="Días"
                  size="small"
                  InputProps={{
                    inputComponent: RucTextMask,
                  }}
                  onBlur={(e) => {
                    let newval =
                      e.target.value !== ""
                        ? parseInt(e.target.value.replace(/\s/g, ""))
                        : 0;
                    setFormulas({
                      ...formulas,
                      [e.target.name]: newval,
                    });
                  }}
                />
              </Box>
            </Box>

            <Box
              display="flex"
              flexDirection="row"
              justifyContent="center"
              p={0}
              mt={3}
            >
              <Button
                variant="contained"
                color="secondary"
                size="large"
                className={classes.buttonCalcular}
                onClick={async () => await updateFormulasSimulador(formulas)}
                disableElevation
              >
                Actualizar
              </Button>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </>
  );
}
